import { connect } from 'react-redux'
import PlayerComponent from "../components/PlayerComponent";
import { changePlayTime, nextBtnClicked, setPlay, setPlayAll,startPlay, addTween ,addSlideLabelData} from "../actions/index"

const mapStateToProps = (state, ownProps) => ({
  projectData : state.project,
  localStore : state.localStore,
  t1 : state.localStore.get('t1'),
  browserName: state.localStore.get("browserName"),
  playAllThumb: state.localStore.get("audioPlayHead"),
  playThumb : state.project.getIn(["scenes", state.localStore.get("selectedScene"), "playHeadValue"]),
  selectedScene : state.localStore.get("selectedScene"),
  playSceneStartTime:  state.project.getIn(["scenes", state.localStore.get("selectedScene"), "startTime"]),
  isPlay              :   state.localStore.get('isPlay'),
  isPlayAll : state.localStore.get('isPlayAll'),
  playSceneDuration : state.project.getIn(["scenes", state.localStore.get("selectedScene"), "duration"]),
  userId : ownProps.userId,
  projectDuration: state.project.get("duration"),
  autoPlay : state.localStore.get('autoPlay'),
  zoomFactor : state.localStore.get('zoomFactor')
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  changePlayTime:(data) => {
    dispatch(changePlayTime(data))
  },
  setPlay: (data) => {
    dispatch(setPlay(data))
  },
  setPlayAll: (data) => {
    dispatch(setPlayAll(data))
  },
  startPlay: (data, source, playHead, sceneStart) => {
    dispatch(startPlay(data, source, playHead, sceneStart))
  },
  addTween: (data,tweenType) => {
    dispatch(addTween(data,tweenType))
  },
  nextBtnClicked : (data) => {
    dispatch(nextBtnClicked(data))
  },
  addSlideLabelData: (data) => {
    dispatch(addSlideLabelData(data))
  },
})

const Player = connect(
  mapStateToProps,
  mapDispatchToProps
)(PlayerComponent)

export default Player


// WEBPACK FOOTER //
// ./src/containers/Player.js